
<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn-upload {
  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 30px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.collapse-arrow .feather-icon {
  transform: rotate(-180deg);
  transition: 0.3s transform ease-in-out;
  display: inline-block;
}

.collapsed .collapse-arrow .feather-icon {
  transform: rotate(0deg);
}
.nav-tabs .nav-link {
  color: black;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #24519c !important;
  font-weight: bold !important;
  background: none !important;
  border: none !important;
}
/* table td input {
  width :15px !important;
  height :100% !important;
  margin-left: 15px;
} */
</style>

<template>
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3 pr-xl-4">
          <div class="card">
            <div class="card-header font-weight-bold">Pengaturan Profil</div>
            <ul class="list-group list-group-flush nav nav-tabs" id="nav-tab" role="tablist">
              <li class="list-group-item p-0">
                <a
                  href="#nav-data-petugas"
                  class="nav-link text-black router-link-exact-active router-link-active py-3 active"
                  id="nav-data-petugas-tab"
                  data-toggle="tab"
                  role="tab"
                  aria-controls="nav-data-petugas"
                  aria-selected="true"
                >
                  Data Petugas
                </a
                >
              </li>
              <li class="list-group-item p-0" v-show="cekRoleProfile('ROLE_PETUGAS_IAPI')">
                <a
                  class="nav-link text-black py-3"
                  id="nav-hak-akses-tab"
                  data-toggle="tab"
                  href="#nav-hak-akses"
                  role="tab"
                  aria-controls="nav-hak-akses"
                  aria-selected="false"
                >
                  Hak Akses
                </a>
              </li>
              <li class="list-group-item p-0"></li>
            </ul>
          </div>          
        </div>
        <div class="tab-content col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8" id="nav-tabContent">
          <div class="mt-3 tab-pane fade show active" id="nav-data-petugas" role="tabpanel" aria-labelledby="nav-data-petugas-tab">
            <div class="card">
              <div class="card-header font-weight-bold">Data Petugas</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8 order-2 order-sm-2 order-md-1 order-lg-1 order-xl-1">
                    <form>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="name" class="font-weight-bold">Nama Petugas</label>
                          <input
                            type="text"
                            class="form-control"
                            id="name"
                            placeholder="Masukkan Nama Petugas"
                            v-model="formData.name"
                            :class="{
                              'is-invalid': $v.formData.name.$error
                            }"
                          />
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="email" class="font-weight-bold">Email Petugas</label>
                          <input
                            type="email"
                            class="form-control"
                            id="email"
                            placeholder="Masukkan Email Petugas"
                            v-model="formData.email"
                            :class="{
                              'is-invalid': $v.formData.email.$error
                            }"
                          />
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="noTelephone" class="font-weight-bold">No Telephone</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="noTelephone"
                            placeholder="Masukkan No Telephone Petugas"
                            v-model="formData.noTelephone"
                          />
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="divisi" class="font-weight-bold">Divisi</label>
                          <multiselect
                            label="namaDivisi"
                            required
                            placeholder="Pilih Divisi"
                            @input="pilihDivisi"
                            v-model="multi_master_divisi"
                            :options="optionMasterDivisi"   
                            :class="{
                              'has-error': $v.multi_master_divisi.$error
                            }"                         
                          ></multiselect>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="cabang" class="font-weight-bold">Cabang</label>
                          <multiselect
                            label="namaCabang"
                            required
                            placeholder="Pilih Cabang"
                            @input="pilihCabang"
                            v-model="multi_master_cabang"
                            :options="optionMasterCabang"  
                            :class="{
                              'has-error': $v.multi_master_cabang.$error
                            }"                          
                          ></multiselect>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="usename" class="font-weight-bold">Username</label>
                          <input 
                            type="text" 
                            class="form-control" 
                            id="usename" 
                            placeholder="Username Petugas" 
                            v-model="formData.username"
                            :class="{
                              'is-invalid': $v.formData.username.$error
                            }"
                          />
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="pass" class="font-weight-bold">Password</label>
                          <input type="password" class="form-control" id="pass" v-model="formData.password"/>
                        </div>
                      </div>
                      <CCol sm="12 mb-4 pl-0">
                        <label for class="font-weight-bold">Status</label>
                        <br />
                        <div class="d-flex align-items-center">
                          <div
                            class="custom-control custom-radio custom-control-inline"
                          >
                            <input
                              type="radio"
                              class="custom-control-input"
                              name="customRadio"
                              id="aktif"
                              value="1"
                              v-model="formData.status"
                              checked
                            />
                            <label class="custom-control-label" for="aktif"
                              >Aktif</label
                            >
                          </div>
                          <div
                            class="custom-control custom-radio custom-control-inline"
                          >
                            <input
                              type="radio"
                              class="custom-control-input"
                              name="customRadio"
                              id="tidak_aktif"
                              value="0"
                              v-model="formData.status"
                            />
                            <label
                              class="custom-control-label"
                              for="tidak_aktif"
                              >Tidak Aktif</label
                            >
                          </div>
                        </div>
                      </CCol>    
                               
                    </form>
                    
                  </div>
                  
                  <div class="col-md-4 order-1 order-sm-1 order-md-2 order-lg-2 order-xl-2">
                    <div class="text-center mt-3">
                      <img
                        :src="`${baseUrl}/files?filename=${formData.foto}&path=users`"
                        style="width:120px"
                        class="card-img-top img img-responsive rounded-circle elevation-2 border"
                        alt="User Picture"
                        @error="imgError"
                      />
                      <div class="mt-2">
                        <div class="upload-btn-wrapper">
                          <button class="btn-upload">Unggah Gambar</button>
                          <input type="file" name="myfile" />
                        </div>
                      </div>
                    </div>
                  </div>
                  

                </div>
                <div class="row">
                  <div class="col-md-12 ">
                    <Button class="btn btn-md btn-success px-4 py-2 float-right" type="submit" color="success" @click="postData" v-show="!cekRoleProfile('ROLE_PETUGAS_IAPI')">
                        Ubah
                    </Button>    
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-3 tab-pane fade"
            id="nav-hak-akses"
            role="tabpanel"
            aria-labelledby="nav-hak-akses-tab"
          >
            <div class="card">
              <div class="card-header font-weight-bold">Hak Akses</div>
              <div class="card-body">
                <div class="accordion" id="accordionExample">

                  <!-- Data Master -->
                  <div class="card shadow">
                    <div
                      class="card-header d-flex align-items-center"
                      id="headingOne"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                      style="cursor: pointer"
                    >
                      <h6 class="mb-0 font-weight-bold">
                        Data Master
                      </h6>
                      <div class="ml-auto pr-2 collapse-arrow">
                        <i
                          class="fa fa-chevron-down feather-icon"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>

                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    id="terms"
                                    type="checkbox"     
                                    :checked="!DataMaster.ROLE_MENU_MASTER"                                                                  
                                    @change="pilihRole($event, 'ROLE_MENU_MASTER')"                                    
                                  />
                                </th>
                                <th>Data Master</th>
                                <th>Create</th>
                                <th>Read</th>
                                <th>Update</th>
                                <th>Delete</th>
                                <th>Ekspor Excel</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="terms"
                                    type="checkbox"
                                    :checked="!DataMaster.ROLE_INFORMASI_UMUM"
                                    @change="pilihRole($event, 'ROLE_INFORMASI_UMUM')"                                    
                                  />
                                </td>
                                <td for="terms">Master Informasi Umum</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_INFORMASI_UMUM"
                                    @change="changeCrudAction($event, 'status_create','ROLE_INFORMASI_UMUM')"
                                    type="checkbox"
                                    id="role-informasi-umum-create"
                                    v-model="InformasiUmum.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_INFORMASI_UMUM"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_INFORMASI_UMUM')"
                                    id="role-informasi-umum-read"
                                    v-model="InformasiUmum.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_INFORMASI_UMUM"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_INFORMASI_UMUM')"
                                    id="role-informasi-umum-update"
                                    v-model="InformasiUmum.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_INFORMASI_UMUM"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_INFORMASI_UMUM')"
                                    id="role-informasi-umum-delete"
                                    v-model="InformasiUmum.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_INFORMASI_UMUM"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_INFORMASI_UMUM')"
                                    id="role-informasi-umum-expor"
                                    v-model="InformasiUmum.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="terms"
                                    type="checkbox"                     
                                    :checked="!DataMaster.ROLE_ARTIKEL"               
                                    @change="pilihRole($event, 'ROLE_ARTIKEL')"                                    
                                  />
                                </td>
                                <td for="terms">Master Artikel</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_ARTIKEL"
                                    @change="changeCrudAction($event, 'status_create','ROLE_ARTIKEL')"
                                    type="checkbox"
                                    id="role-artikel-create"
                                    v-model="masterArtikel.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_ARTIKEL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_ARTIKEL')"
                                    id="role-artikel-read"
                                    v-model="masterArtikel.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_ARTIKEL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_ARTIKEL')"
                                    id="role-artikel-update"
                                    v-model="masterArtikel.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_ARTIKEL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_ARTIKEL')"
                                    id="role-artikel-delete"
                                    v-model="masterArtikel.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_ARTIKEL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_ARTIKEL')"
                                    id="role-artikel-expor"
                                    v-model="masterArtikel.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!DataMaster.ROLE_DIVISI"
                                    @change="pilihRole($event, 'ROLE_DIVISI')"
                                    :value="{
                                      nama_role: 'ROLE_DIVISI',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Divisi</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_DIVISI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_DIVISI')"
                                    id="role-divisi-tambah"
                                    v-model="divisi.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_DIVISI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_DIVISI')"
                                    id="role-divisi-read"
                                    v-model="divisi.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_DIVISI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_DIVISI')"
                                    id="role-divisi-update"
                                    v-model="divisi.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_DIVISI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_DIVISI')"
                                    id="role-divisi-delete"
                                    v-model="divisi.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_DIVISI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_DIVISI')"
                                    id="role-divisi-expor"
                                    v-model="divisi.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!DataMaster.ROLE_LEVEL"
                                    @change="pilihRole($event, 'ROLE_LEVEL')"
                                    :value="{
                                      nama_role: 'ROLE_LEVEL',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Level</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_LEVEL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_LEVEL')"
                                    id="role-level-tambah"
                                    v-model="level.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_LEVEL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_LEVEL')"
                                    id="role-level-read"
                                    v-model="level.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_LEVEL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_LEVEL')"
                                    id="role-level-update"
                                    v-model="level.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_LEVEL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_LEVEL')"
                                    id="role-level-delete"
                                    v-model="level.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_LEVEL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_LEVEL')"
                                    id="role-level-export"
                                    v-model="level.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!DataMaster.ROLE_TEST_CENTER"
                                    @change="
                                      pilihRole($event, 'ROLE_TEST_CENTER')
                                    "
                                    :value="{
                                      nama_role: 'ROLE_TEST_CENTER',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Test Center</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_TEST_CENTER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_TEST_CENTER')"
                                    id="role-tc-create"
                                    v-model="testCenter.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_TEST_CENTER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_TEST_CENTER')"
                                    id="role-tc-read"
                                    v-model="testCenter.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_TEST_CENTER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_TEST_CENTER')"
                                    id="role-tc-update"
                                    v-model="testCenter.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_TEST_CENTER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_TEST_CENTER')"
                                    id="role-tc-delete"
                                    v-model="testCenter.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_TEST_CENTER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_TEST_CENTER')"
                                    id="role-tc-export"
                                    v-model="testCenter.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"         
                                    :checked="!DataMaster.ROLE_MASTER_JADWAL_TC"                         
                                    @change="pilihRole($event, 'ROLE_MASTER_JADWAL_TC')"
                                    :value="{
                                      nama_role: 'ROLE_MASTER_JADWAL_TC',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Jadwal Test Center</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_JADWAL_TC"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_MASTER_JADWAL_TC')"
                                    id="role-jadwal-tc-create"
                                    v-model="jadwalTc.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_JADWAL_TC"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_MASTER_JADWAL_TC')"
                                    id="role-jadwal-tc-read"
                                    v-model="jadwalTc.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_JADWAL_TC"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_MASTER_JADWAL_TC')"
                                    id="role-jadwal-tc-update"
                                    v-model="jadwalTc.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_JADWAL_TC"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_MASTER_JADWAL_TC')"
                                    id="role-jadwal-tc-delete"
                                    v-model="jadwalTc.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_JADWAL_TC"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_MASTER_JADWAL_TC')"
                                    id="role-jadwal-tc-export"
                                    v-model="jadwalTc.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!DataMaster.ROLE_CABANG"
                                    @change="pilihRole($event, 'ROLE_CABANG')"
                                    :value="{
                                      nama_role: 'ROLE_CABANG',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Cabang</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_CABANG"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_CABANG')"
                                    id="role-cabang-create"
                                    v-model="cabang.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_CABANG"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_CABANG')"
                                    id="role-cabang-read"
                                    v-model="cabang.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_CABANG"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_CABANG')"
                                    id="role-cabang-update"
                                    v-model="cabang.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_CABANG"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_CABANG')"
                                    id="role-cabang-delete"
                                    v-model="cabang.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_CABANG"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_CABANG')"
                                    id="role-cabang-export"
                                    v-model="cabang.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_periode"
                                    type="checkbox"
                                    :checked="!DataMaster.ROLE_PERIODE"
                                    @change="pilihRole($event, 'ROLE_PERIODE')"
                                    :value="{
                                      nama_role: 'ROLE_PERIODE',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Periode</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_PERIODE"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PERIODE')"
                                    id="role-periode-create"
                                    v-model="periode.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_PERIODE"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PERIODE')"
                                    id="role-periode-read"
                                    v-model="periode.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_PERIODE"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_PERIODE')"
                                    id="role-periode-update"
                                    v-model="periode.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_PERIODE"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_PERIODE')"
                                    id="role-periode-delete"
                                    v-model="periode.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_PERIODE"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_PERIODE')"
                                    id="role-periode-export"
                                    v-model="periode.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_kupon"
                                    type="checkbox"
                                    :checked="!DataMaster.ROLE_KUPON"
                                    @change="pilihRole($event, 'ROLE_KUPON')"
                                    :value="{
                                      nama_role: 'ROLE_KUPON',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Kupon</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_KUPON"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_KUPON')"
                                    id="role-kupon-create"
                                    v-model="kupon.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_KUPON"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_KUPON')"
                                    id="role-kupon-read"
                                    v-model="kupon.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_KUPON"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_KUPON')"
                                    id="role-kupon-update"
                                    v-model="kupon.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_KUPON"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_KUPON')"
                                    id="role-kupon-delete"
                                    v-model="kupon.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_KUPON"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_KUPON')"
                                    id="role-kupon-export"
                                    v-model="kupon.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!DataMaster.ROLE_MASTER_LOKASI"
                                    @change="pilihRole($event, 'ROLE_MASTER_LOKASI')"
                                    :value="{
                                      nama_role: 'ROLE_MASTER_LOKASI',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Lokasi</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_LOKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_MASTER_LOKASI')"
                                    id="role-lokasi-create"
                                    v-model="lokasi.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_LOKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_MASTER_LOKASI')"
                                    id="role-lokasi-read"
                                    v-model="lokasi.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_LOKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_MASTER_LOKASI')"
                                    id="role-lokasi-update"
                                    v-model="lokasi.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_LOKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_MASTER_LOKASI')"
                                    id="role-lokasi-delete"
                                    v-model="lokasi.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_LOKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_MASTER_LOKASI')"
                                    id="role-lokasi-export"
                                    v-model="lokasi.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!DataMaster.ROLE_DOKUMEN"
                                    @change="pilihRole($event, 'ROLE_DOKUMEN')"
                                    :value="{
                                      nama_role: 'ROLE_DOKUMEN',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Dokumen</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_DOKUMEN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_DOKUMEN')"
                                    id="role-dokumen-create"
                                    v-model="dokumen.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_DOKUMEN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_DOKUMEN')"
                                    id="role-dokumen-read"
                                    v-model="dokumen.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_DOKUMEN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_DOKUMEN')"
                                    id="role-dokumen-update"
                                    v-model="dokumen.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_DOKUMEN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_DOKUMEN')"
                                    id="role-dokumen-delete"
                                    v-model="dokumen.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_DOKUMEN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_DOKUMEN')"
                                    id="role-dokumen-export"
                                    v-model="dokumen.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_karir"
                                    type="checkbox"
                                    :checked="!DataMaster.ROLE_KARIR"
                                    @change="pilihRole($event, 'ROLE_KARIR')"
                                    :value="{
                                      nama_role: 'ROLE_KARIR',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Karir</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_KARIR"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_KARIR')"
                                    id="role-karir-create"
                                    v-model="karir.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_KARIR"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_KARIR')"
                                    id="role-karir-read"
                                    v-model="karir.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_KARIR"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_KARIR')"
                                    id="role-karir-update"
                                    v-model="karir.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_KARIR"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_KARIR')"
                                    id="role-karir-delete"
                                    v-model="karir.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_KARIR"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_KARIR')"
                                    id="role-karir-export"
                                    v-model="karir.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_karir"
                                    type="checkbox"         
                                    :checked="!DataMaster.ROLE_MATA_KULIAH"                           
                                    @change="pilihRole($event, 'ROLE_MATA_KULIAH')"
                                    :value="{
                                      nama_role: 'ROLE_MATA_KULIAH',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Mata Kuliah</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MATA_KULIAH"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_MATA_KULIAH')"
                                    id="role-mata-uji-create"
                                    v-model="mataKuliah.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MATA_KULIAH"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_MATA_KULIAH')"
                                    id="role-mata-uji-read"
                                    v-model="mataKuliah.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MATA_KULIAH"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_MATA_KULIAH')"
                                    id="role-mata-uji-update"
                                    v-model="mataKuliah.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MATA_KULIAH"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_MATA_KULIAH')"
                                    id="role-mata-uji-delete"
                                    v-model="mataKuliah.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MATA_KULIAH"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_MATA_KULIAH')"
                                    id="role-mata-uji-export"
                                    v-model="mataKuliah.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_karir"
                                    type="checkbox"         
                                    :checked="!DataMaster.ROLE_MASTER_MATA_UJI"                           
                                    @change="pilihRole($event, 'ROLE_MASTER_MATA_UJI')"
                                    :value="{
                                      nama_role: 'ROLE_MASTER_MATA_UJI',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Mata Uji</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_MATA_UJI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_MASTER_MATA_UJI')"
                                    id="role-mata-uji-create"
                                    v-model="mataUji.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_MATA_UJI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_MASTER_MATA_UJI')"
                                    id="role-mata-uji-read"
                                    v-model="mataUji.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_MATA_UJI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_MASTER_MATA_UJI')"
                                    id="role-mata-uji-update"
                                    v-model="mataUji.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_MATA_UJI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_MASTER_MATA_UJI')"
                                    id="role-mata-uji-delete"
                                    v-model="mataUji.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_MASTER_MATA_UJI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_MASTER_MATA_UJI')"
                                    id="role-mata-uji-export"
                                    v-model="mataUji.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_karir"
                                    type="checkbox"         
                                    :checked="!DataMaster.ROLE_PAKTA_INTEGRITAS"                           
                                    @change="pilihRole($event, 'ROLE_PAKTA_INTEGRITAS')"
                                    :value="{
                                      nama_role: 'ROLE_PAKTA_INTEGRITAS',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Pakta Integritas</td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_PAKTA_INTEGRITAS"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PAKTA_INTEGRITAS')"
                                    id="role-paktaintegritas-create"
                                    v-model="paktaIntegritas.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_PAKTA_INTEGRITAS"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PAKTA_INTEGRITAS')"
                                    id="role-paktaintegritas-read"
                                    v-model="paktaIntegritas.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_PAKTA_INTEGRITAS"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_PAKTA_INTEGRITAS')"
                                    id="role-paktaintegritas-update"
                                    v-model="paktaIntegritas.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_PAKTA_INTEGRITAS"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_PAKTA_INTEGRITAS')"
                                    id="role-paktaintegritas-delete"
                                    v-model="paktaIntegritas.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="DataMaster.ROLE_PAKTA_INTEGRITAS"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_PAKTA_INTEGRITAS')"
                                    id="role-paktaintegritas-export"
                                    v-model="paktaIntegritas.status_export_excel"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Data Master -->
                  
                  <!-- User Manajemen -->
                  <div class="card shadow">
                    <div
                      class="card-header d-flex align-items-center collapsed"
                      id="headingTwo"
                      data-toggle="collapse"
                      data-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                      style="cursor: pointer"
                    >
                      <h6 class="mb-0 font-weight-bold">User Manajemen</h6>
                      <div class="ml-auto pr-2 collapse-arrow">
                        <i
                          class="fa fa-chevron-down feather-icon"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div
                      id="collapseTwo"
                      class="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    id="terms"
                                    type="checkbox"  
                                    :checked="!Usermanajemen.ROLE_MENU_USER_MANAJEMEN"                                                         
                                    @change="pilihRole($event, 'ROLE_MENU_USER_MANAJEMEN')"                                    
                                  />
                                </th>
                                <th>User Manajemen</th>
                                <th>Create</th>
                                <th>Read</th>
                                <th>Update</th>
                                <th>Delete</th>
                                <th>Ekspor Excel</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id-petugas-bo"
                                    type="checkbox"
                                    :checked="!Usermanajemen.ROLE_PETUGAS_IAPI"
                                    @change="pilihRole($event, 'ROLE_PETUGAS_IAPI')"
                                    :value="{
                                      nama_role: 'ROLE_PETUGAS_IAPI',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Petugas Back Office</td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_IAPI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PETUGAS_IAPI')"
                                    id="role-karir-create"
                                    v-model="petugasBO.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_IAPI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PETUGAS_IAPI')"
                                    id="role-karir-read"
                                    v-model="petugasBO.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_IAPI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_PETUGAS_IAPI')"
                                    id="role-karir-update"
                                    v-model="petugasBO.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_IAPI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_PETUGAS_IAPI')"
                                    id="role-karir-delete"
                                    v-model="petugasBO.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_IAPI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_PETUGAS_IAPI')"
                                    id="role-karir-export"
                                    v-model="petugasBO.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id-petugas-lms"
                                    type="checkbox"
                                    :checked="!Usermanajemen.ROLE_PETUGAS_LMS"
                                    @change="pilihRole($event, 'ROLE_PETUGAS_LMS')"
                                    :value="{
                                      nama_role: 'ROLE_PETUGAS_LMS',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Petugas LMS</td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_LMS"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PETUGAS_LMS')"
                                    id="role-petugas-lms-create"
                                    v-model="petugasLms.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_LMS"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PETUGAS_LMS')"
                                    id="role-petugas-lms-read"
                                    v-model="petugasLms.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_LMS"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_PETUGAS_LMS')"
                                    id="role-petugas-lms-update"
                                    v-model="petugasLms.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_LMS"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_PETUGAS_LMS')"
                                    id="role-petugas-lms-delete"
                                    v-model="petugasLms.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_LMS"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_PETUGAS_LMS')"
                                    id="role-petugas-lms-export"
                                    v-model="petugasLms.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id-petugas-tc"
                                    type="checkbox"
                                    :checked="!Usermanajemen.ROLE_PETUGAS_TEST_CENTER"
                                    @change="pilihRole($event, 'ROLE_PETUGAS_TEST_CENTER')"
                                    :value="{
                                      nama_role: 'ROLE_PETUGAS_TEST_CENTER',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Petugas Test Center</td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_TEST_CENTER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PETUGAS_TEST_CENTER')"
                                    id="role-petugas-tc-create"
                                    v-model="petugasTc.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_TEST_CENTER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PETUGAS_TEST_CENTER')"
                                    id="role-petugas-tc-read"
                                    v-model="petugasTc.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_TEST_CENTER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_PETUGAS_TEST_CENTER')"
                                    id="role-petugas-tc-update"
                                    v-model="petugasTc.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_TEST_CENTER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_PETUGAS_TEST_CENTER')"
                                    id="role-petugas-tc-delete"
                                    v-model="petugasTc.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_TEST_CENTER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_PETUGAS_TEST_CENTER')"
                                    id="role-petugas-tc-export"
                                    v-model="petugasTc.status_export_excel"
                                  />
                                </td>
                              </tr>                              
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id-petugas-bank-soal"
                                    type="checkbox"
                                    :checked="!Usermanajemen.ROLE_PETUGAS_BANK_SOAL"
                                    @change="pilihRole($event, 'ROLE_PETUGAS_BANK_SOAL')"
                                    :value="{
                                      nama_role: 'ROLE_PETUGAS_BANK_SOAL',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Petugas Bank Soal</td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_BANK_SOAL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PETUGAS_BANK_SOAL')"
                                    id="role-petugas-bank-soal-create"
                                    v-model="petugasBankSoal.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_BANK_SOAL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PETUGAS_BANK_SOAL')"
                                    id="role-petugas-bank-soal-read"
                                    v-model="petugasBankSoal.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_BANK_SOAL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_PETUGAS_BANK_SOAL')"
                                    id="role-petugas-bank-soal-update"
                                    v-model="petugasBankSoal.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_BANK_SOAL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_PETUGAS_BANK_SOAL')"
                                    id="role-petugas-bank-soal-delete"
                                    v-model="petugasBankSoal.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_BANK_SOAL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_PETUGAS_BANK_SOAL')"
                                    id="role-petugas-bank-soal-export"
                                    v-model="petugasBankSoal.status_export_excel"
                                  />
                                </td>
                              </tr>                              
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id-petugas-bo"
                                    type="checkbox"
                                    :checked="!Usermanajemen.ROLE_PETUGAS_GRADER"
                                    @change="pilihRole($event, 'ROLE_PETUGAS_GRADER')"
                                    :value="{
                                      nama_role: 'ROLE_PETUGAS_GRADER',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Petugas Grader</td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_GRADER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PETUGAS_GRADER')"
                                    id="role-petugas-grader-create"
                                    v-model="petugasGrader.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_GRADER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PETUGAS_GRADER')"
                                    id="role-petugas-grader-read"
                                    v-model="petugasGrader.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_GRADER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_PETUGAS_GRADER')"
                                    id="role-petugas-grader-update"
                                    v-model="petugasGrader.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_GRADER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_PETUGAS_GRADER')"
                                    id="role-petugas-grader-delete"
                                    v-model="petugasGrader.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Usermanajemen.ROLE_PETUGAS_GRADER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_PETUGAS_GRADER')"
                                    id="role-petugas-grader-export"
                                    v-model="petugasGrader.status_export_excel"
                                  />
                                </td>
                              </tr>                              
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- User Manajemen -->
                  
                  <!-- Sertifikasi -->
                  <div class="card shadow">
                    <div
                      class="card-header d-flex align-items-center collapsed"
                      id="headingThree"
                      data-toggle="collapse"
                      data-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                      style="cursor: pointer"
                    >
                      <h6 class="mb-0 font-weight-bold">Sertifikasi</h6>
                      <div class="ml-auto pr-2 collapse-arrow">
                        <i
                          class="fa fa-chevron-down feather-icon"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div
                      id="collapseThree"
                      class="collapse"
                      aria-labelledby="headingThree"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    id="terms"
                                    type="checkbox"                 
                                    :checked="!Sertifikasi.ROLE_MENU_SERTIFIKASI"                   
                                    @change="pilihRole($event, 'ROLE_MENU_SERTIFIKASI')"                                    
                                  />
                                </th>
                                <th>Sertifikasi</th>
                                <th>Create</th>
                                <th>Read</th>
                                <th>Update</th>
                                <th>Delete</th>
                                <th>Ekspor Excel</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Sertifikasi.ROLE_MASTER_SERTIFIKASI"
                                    @change="pilihRole($event, 'ROLE_MASTER_SERTIFIKASI')"
                                    :value="{
                                      nama_role: 'ROLE_MASTER_SERTIFIKASI',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master Sertifikasi</td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_MASTER_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_MASTER_SERTIFIKASI')"
                                    id="role-sertifikasi-create"
                                    v-model="sertifikasi.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_MASTER_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_MASTER_SERTIFIKASI')"
                                    id="role-sertifikasi-read"
                                    v-model="sertifikasi.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_MASTER_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_MASTER_SERTIFIKASI')"
                                    id="role-sertifikasi-update"
                                    v-model="sertifikasi.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_MASTER_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_MASTER_SERTIFIKASI')"
                                    id="role-sertifikasi-delete"
                                    v-model="sertifikasi.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_MASTER_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_MASTER_SERTIFIKASI')"
                                    id="role-sertifikasi-export"
                                    v-model="sertifikasi.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Sertifikasi.ROLE_DATA_PESERTA_SERTIFIKASI"
                                    @change="pilihRole($event, 'ROLE_DATA_PESERTA_SERTIFIKASI')"
                                    :value="{
                                      nama_role: 'ROLE_DATA_PESERTA_SERTIFIKASI',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Data Peserta</td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_DATA_PESERTA_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_DATA_PESERTA_SERTIFIKASI')"
                                    id="role-peserta-sertifikasi-create"
                                    v-model="dataPesertaSertifikasi.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_DATA_PESERTA_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_DATA_PESERTA_SERTIFIKASI')"
                                    id="role-peserta-sertifikasi-read"
                                    v-model="dataPesertaSertifikasi.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_DATA_PESERTA_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_DATA_PESERTA_SERTIFIKASI')"
                                    id="role-peserta-sertifikasi-update"
                                    v-model="dataPesertaSertifikasi.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_DATA_PESERTA_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_DATA_PESERTA_SERTIFIKASI')"
                                    id="role-peserta-sertifikasi-delete"
                                    v-model="dataPesertaSertifikasi.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_DATA_PESERTA_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_DATA_PESERTA_SERTIFIKASI')"
                                    id="role-peserta-sertifikasi-export"
                                    v-model="dataPesertaSertifikasi.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Sertifikasi.ROLE_PENGAJUAN_SERTIFIKASI"
                                    @change=" pilihRole($event, 'ROLE_PENGAJUAN_SERTIFIKASI')"
                                    :value="{
                                      nama_role: 'ROLE_PENGAJUAN_SERTIFIKASI',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Pengajuan Sertifikat</td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_PENGAJUAN_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PENGAJUAN_SERTIFIKASI')"
                                    id="role-pengajuan-sertifikasi-create"
                                    v-model="pengajuanSertifikasi.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_PENGAJUAN_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PENGAJUAN_SERTIFIKASI')"
                                    id="role-pengajuan-sertifikasi-read"
                                    v-model="pengajuanSertifikasi.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_PENGAJUAN_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_PENGAJUAN_SERTIFIKASI')"
                                    id="role-pengajuan-sertifikasi-update"
                                    v-model="pengajuanSertifikasi.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_PENGAJUAN_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_PENGAJUAN_SERTIFIKASI')"
                                    id="role-pengajuan-sertifikasi-delete"
                                    v-model="pengajuanSertifikasi.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_PENGAJUAN_SERTIFIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_PENGAJUAN_SERTIFIKASI')"
                                    id="role-pengajuan-sertifikasi-export"
                                    v-model="pengajuanSertifikasi.status_export_excel"
                                  />
                                </td>
                              </tr>                              
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"     
                                    :checked="!Sertifikasi.ROLE_RIWAYAT_PESERTA"
                                    @change="pilihRole($event, 'ROLE_RIWAYAT_PESERTA')"
                                    :value="{
                                      nama_role: 'ROLE_RIWAYAT_PESERTA',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Riwayat Peserta</td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_RIWAYAT_PESERTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_RIWAYAT_PESERTA')"
                                    id="role-riwayat-peserta-create"
                                    v-model="riwayatPeserta.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_RIWAYAT_PESERTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_RIWAYAT_PESERTA')"
                                    id="role-riwayat-peserta-read"
                                    v-model="riwayatPeserta.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_RIWAYAT_PESERTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_RIWAYAT_PESERTA')"
                                    id="role-riwayat-peserta-update"
                                    v-model="riwayatPeserta.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_RIWAYAT_PESERTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_RIWAYAT_PESERTA')"
                                    id="role-riwayat-peserta-delete"
                                    v-model="riwayatPeserta.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Sertifikasi.ROLE_RIWAYAT_PESERTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_RIWAYAT_PESERTA')"
                                    id="role-riwayat-peserta-export"
                                    v-model="riwayatPeserta.status_export_excel"
                                  />
                                </td>
                              </tr> 
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Sertifikasi -->

                  <!-- RPL -->
                  <div class="card shadow">
                    <div
                      class="card-header d-flex align-items-center collapsed"
                      id="headingFour"
                      data-toggle="collapse"
                      data-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                      style="cursor: pointer"
                    >
                      <h6 class="mb-0 font-weight-bold">RPL</h6>
                      <div class="ml-auto pr-2 collapse-arrow">
                        <i
                          class="fa fa-chevron-down feather-icon"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div
                      id="collapseFour"
                      class="collapse"
                      aria-labelledby="headingFour"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    id="terms"
                                    type="checkbox"      
                                    :checked="!Rpl.ROLE_MENU_RPL"                              
                                    @change="pilihRole($event, 'ROLE_MENU_RPL')"                                    
                                  />
                                </th>
                                <th>RPL</th>
                                <th>Create</th>
                                <th>Read</th>
                                <th>Update</th>
                                <th>Delete</th>
                                <th>Ekspor Excel</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Rpl.ROLE_MASTER_RPL"
                                    @change="pilihRole($event, 'ROLE_MASTER_RPL')"
                                    :value="{
                                      nama_role: 'ROLE_MASTER_RPL',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Master RPL</td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_MASTER_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_MASTER_RPL')"
                                    id="role-master-rpl-create"
                                    v-model="masterRpl.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_MASTER_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_MASTER_RPL')"
                                    id="role-master-rpl-read"
                                    v-model="masterRpl.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_MASTER_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_MASTER_RPL')"
                                    id="role-master-rpl-update"
                                    v-model="masterRpl.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_MASTER_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_MASTER_RPL')"
                                    id="role-master-rpl-delete"
                                    v-model="masterRpl.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_MASTER_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_MASTER_RPL')"
                                    id="role-master-rpl-export"
                                    v-model="masterRpl.status_export_excel"
                                  />
                                </td>
                              </tr>

                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Rpl.ROLE_DATA_PESERTA_RPL"
                                    @change="pilihRole($event, 'ROLE_DATA_PESERTA_RPL')"
                                    :value="{
                                      nama_role: 'ROLE_DATA_PESERTA_RPL',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Data Peserta RPL</td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_DATA_PESERTA_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_DATA_PESERTA_RPL')"
                                    id="role-peserta-rpl-create"
                                    v-model="pesertaRpl.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_DATA_PESERTA_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_DATA_PESERTA_RPL')"
                                    id="role-peserta-rpl-read"
                                    v-model="pesertaRpl.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_DATA_PESERTA_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_DATA_PESERTA_RPL')"
                                    id="role-peserta-rpl-update"
                                    v-model="pesertaRpl.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_DATA_PESERTA_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_DATA_PESERTA_RPL')"
                                    id="role-peserta-rpl-delete"
                                    v-model="pesertaRpl.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_DATA_PESERTA_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_DATA_PESERTA_RPL')"
                                    id="role-peserta-rpl-export"
                                    v-model="pesertaRpl.status_export_excel"
                                  />
                                </td>
                              </tr>

                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Rpl.ROLE_RIWAYAT_PESERTA_RPL"
                                    @change="pilihRole($event, 'ROLE_RIWAYAT_PESERTA_RPL')"
                                    :value="{
                                      nama_role: 'ROLE_RIWAYAT_PESERTA_RPL',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Riwayat Peserta RPL</td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_RIWAYAT_PESERTA_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_RIWAYAT_PESERTA_RPL')"
                                    id="role-riwayat-peserta-rpl-create"
                                    v-model="riwayatPesertaRpl.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_RIWAYAT_PESERTA_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_RIWAYAT_PESERTA_RPL')"
                                    id="role-riwayat-peserta-rpl-read"
                                    v-model="riwayatPesertaRpl.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_RIWAYAT_PESERTA_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_RIWAYAT_PESERTA_RPL')"
                                    id="role-riwayat-peserta-rpl-update"
                                    v-model="riwayatPesertaRpl.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_RIWAYAT_PESERTA_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_RIWAYAT_PESERTA_RPL')"
                                    id="role-riwayat-peserta-rpl-delete"
                                    v-model="riwayatPesertaRpl.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_RIWAYAT_PESERTA_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_RIWAYAT_PESERTA_RPL')"
                                    id="role-riwayat-peserta-rpl-export"
                                    v-model="riwayatPesertaRpl.status_export_excel"
                                  />
                                </td>
                              </tr>

                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Rpl.ROLE_WAIVER"
                                    @change="pilihRole($event, 'ROLE_WAIVER')"
                                    :value="{
                                      nama_role: 'ROLE_WAIVER',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Waiver</td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_WAIVER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_WAIVER')"
                                    id="role-waiver-create"
                                    v-model="waiver.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_WAIVER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_WAIVER')"
                                    id="role-waiver-read"
                                    v-model="waiver.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_WAIVER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_WAIVER')"
                                    id="role-waiver-update"
                                    v-model="waiver.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_WAIVER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_WAIVER')"
                                    id="role-waiver-delete"
                                    v-model="waiver.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_WAIVER"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_WAIVER')"
                                    id="role-waiver-export"
                                    v-model="waiver.status_export_excel"
                                  />
                                </td>
                              </tr>

                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Rpl.ROLE_PENGAJUAN_SERTIFIKAT_RPL"
                                    @change="pilihRole($event, 'ROLE_PENGAJUAN_SERTIFIKAT_RPL')"
                                    :value="{
                                      nama_role: 'ROLE_PENGAJUAN_SERTIFIKAT_RPL',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Pengajuan Sertifikat RPL</td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_PENGAJUAN_SERTIFIKAT_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PENGAJUAN_SERTIFIKAT_RPL')"
                                    id="role-pengajuan-sertifikasi-rpl-create"
                                    v-model="pengajuanSertifikasiRpl.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_PENGAJUAN_SERTIFIKAT_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PENGAJUAN_SERTIFIKAT_RPL')"
                                    id="role-pengajuan-sertifikasi-rpl-read"
                                    v-model="pengajuanSertifikasiRpl.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_PENGAJUAN_SERTIFIKAT_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_PENGAJUAN_SERTIFIKAT_RPL')"
                                    id="role-pengajuan-sertifikasi-rpl-update"
                                    v-model="pengajuanSertifikasiRpl.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_PENGAJUAN_SERTIFIKAT_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_PENGAJUAN_SERTIFIKAT_RPL')"
                                    id="role-pengajuan-sertifikasi-rpl-delete"
                                    v-model="pengajuanSertifikasiRpl.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Rpl.ROLE_PENGAJUAN_SERTIFIKAT_RPL"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_PENGAJUAN_SERTIFIKAT_RPL')"
                                    id="role-pengajuan-sertifikasi-rpl-export"
                                    v-model="pengajuanSertifikasiRpl.status_export_excel"
                                  />
                                </td>
                              </tr>                                               
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- RPL -->
                  
                  <!-- Pelatihan -->
                  <div class="card shadow">
                    <div
                      class="card-header d-flex align-items-center collapsed"
                      id="headingFive"
                      data-toggle="collapse"
                      data-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                      style="cursor: pointer"
                    >
                      <h6 class="mb-0 font-weight-bold">Pelatihan</h6>
                      <div class="ml-auto pr-2 collapse-arrow">
                        <i
                          class="fa fa-chevron-down feather-icon"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div
                      id="collapseFive"
                      class="collapse"
                      aria-labelledby="headingFive"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    id="terms"
                                    type="checkbox"          
                                    :checked="!Pelatihan.ROLE_MENU_PELATIHAN"                          
                                    @change="pilihRole($event, 'ROLE_MENU_PELATIHAN')"                                    
                                  />
                                </th>
                                <th>Pelatihan</th>
                                <th>Create</th>
                                <th>Read</th>
                                <th>Update</th>
                                <th>Delete</th>
                                <th>Ekspor Excel</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"      
                                    :checked="!Pelatihan.ROLE_KODE_PELATIHAN"                         
                                    @change="pilihRole($event, 'ROLE_KODE_PELATIHAN')"
                                    :value="{
                                      nama_role: 'ROLE_KODE_PELATIHAN',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Kode Pelatihan</td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_KODE_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_KODE_PELATIHAN')"
                                    id="role-kode-pelatihan-create"
                                    v-model="kodePelatihan.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_KODE_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_KODE_PELATIHAN')"
                                    id="role-sertifikasi-read"
                                    v-model="kodePelatihan.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_KODE_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_KODE_PELATIHAN')"
                                    id="role-sertifikasi-update"
                                    v-model="kodePelatihan.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_KODE_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_KODE_PELATIHAN')"
                                    id="role-sertifikasi-delete"
                                    v-model="kodePelatihan.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_KODE_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_KODE_PELATIHAN')"
                                    id="role-sertifikasi-export"
                                    v-model="kodePelatihan.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"                                    
                                    :checked="!Pelatihan.ROLE_DAFTAR_PELATIHAN"
                                    @change="pilihRole($event, 'ROLE_DAFTAR_PELATIHAN')"
                                    :value="{
                                      nama_role: 'ROLE_DAFTAR_PELATIHAN',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Daftar Pelatihan</td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DAFTAR_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_DAFTAR_PELATIHAN')"
                                    id="role-daftar-pelatihan-create"
                                    v-model="daftarPelatihan.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DAFTAR_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_DAFTAR_PELATIHAN')"
                                    id="role-daftar-pelatihan-read"
                                    v-model="daftarPelatihan.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DAFTAR_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_DAFTAR_PELATIHAN')"
                                    id="role-daftar-pelatihan-update"
                                    v-model="daftarPelatihan.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DAFTAR_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_DAFTAR_PELATIHAN')"
                                    id="role-sertifikasi-delete"
                                    v-model="daftarPelatihan.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DAFTAR_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_DAFTAR_PELATIHAN')"
                                    id="role-daftar-pelatihan-export"
                                    v-model="daftarPelatihan.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Pelatihan.ROLE_PENYELENGGARA"
                                    @change="pilihRole($event, 'ROLE_PENYELENGGARA')"
                                    :value="{
                                      nama_role: 'ROLE_PENYELENGGARA',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Penyelenggara</td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_PENYELENGGARA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PENYELENGGARA')"
                                    id="role-daftar-penyelenggara-create"
                                    v-model="penyelenggara.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_PENYELENGGARA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PENYELENGGARA')"
                                    id="role-daftar-penyelenggara-read"
                                    v-model="penyelenggara.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_PENYELENGGARA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_PENYELENGGARA')"
                                    id="role-daftar-penyelenggara-update"
                                    v-model="penyelenggara.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_PENYELENGGARA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_PENYELENGGARA')"
                                    id="role-daftar-penyelenggara-delete"
                                    v-model="penyelenggara.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_PENYELENGGARA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_PENYELENGGARA')"
                                    id="role-daftar-pelatihan-export"
                                    v-model="penyelenggara.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Pelatihan.ROLE_INSTRUKTUR"
                                    @change="pilihRole($event, 'ROLE_INSTRUKTUR')"
                                    :value="{
                                      nama_role: 'ROLE_INSTRUKTUR',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Instruktur</td>                                
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_INSTRUKTUR"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_INSTRUKTUR')"
                                    id="role-daftar-instruktur-create"
                                    v-model="instruktur.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_INSTRUKTUR"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_INSTRUKTUR')"
                                    id="role-daftar-instruktur-read"
                                    v-model="instruktur.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_INSTRUKTUR"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_INSTRUKTUR')"
                                    id="role-daftar-instruktur-update"
                                    v-model="instruktur.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_INSTRUKTUR"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_INSTRUKTUR')"
                                    id="role-daftar-instruktur-delete"
                                    v-model="instruktur.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_INSTRUKTUR"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_INSTRUKTUR')"
                                    id="role-daftar-instruktur-export"
                                    v-model="instruktur.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Pelatihan.ROLE_MITRA_PELATIHAN"
                                    @change="pilihRole($event, 'ROLE_MITRA_PELATIHAN')"
                                    :value="{
                                      nama_role: 'ROLE_MITRA_PELATIHAN',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Mitra Pelatihan</td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_MITRA_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_MITRA_PELATIHAN')"
                                    id="role-daftar-mitra-pelatihan-create"
                                    v-model="mitraPelatihan.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_MITRA_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_MITRA_PELATIHAN')"
                                    id="role-daftar-mitra-pelatihan-read"
                                    v-model="mitraPelatihan.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_MITRA_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_MITRA_PELATIHAN')"
                                    id="role-daftar-mitra-pelatihan-update"
                                    v-model="mitraPelatihan.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_MITRA_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_MITRA_PELATIHAN')"
                                    id="role-daftar-mitra-pelatihan-delete"
                                    v-model="mitraPelatihan.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_MITRA_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_MITRA_PELATIHAN')"
                                    id="role-daftar-mitra-pelatihan-export"
                                    v-model="mitraPelatihan.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"                                    
                                    :checked="!Pelatihan.ROLE_DATA_PESERTA_PELATIHAN"
                                    @change="pilihRole($event,'ROLE_DATA_PESERTA_PELATIHAN')"
                                    :value="{
                                      nama_role: 'ROLE_DATA_PESERTA_PELATIHAN',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Data Peserta</td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PESERTA_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_DATA_PESERTA_PELATIHAN')"
                                    id="role-data-peserta-pelatihan-create"
                                    v-model="dataPesertaPelatihan.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PESERTA_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_DATA_PESERTA_PELATIHAN')"
                                    id="role-data-peserta-pelatihan-read"
                                    v-model="dataPesertaPelatihan.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PESERTA_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_DATA_PESERTA_PELATIHAN')"
                                    id="role-data-peserta-pelatihan-update"
                                    v-model="dataPesertaPelatihan.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PESERTA_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_DATA_PESERTA_PELATIHAN')"
                                    id="role-data-peserta-pelatihan-delete"
                                    v-model="dataPesertaPelatihan.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PESERTA_PELATIHAN"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_DATA_PESERTA_PELATIHAN')"
                                    id="role-data-peserta-pelatihan-export"
                                    v-model="dataPesertaPelatihan.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="terms"
                                    type="checkbox"                     
                                    :checked="!Pelatihan.ROLE_DATA_SKP_PESERTA"               
                                    @change="pilihRole($event, 'ROLE_DATA_SKP_PESERTA')"                                    
                                  />
                                </td>
                                <td for="terms">Data SKP Peserta</td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_SKP_PESERTA"
                                    @change="changeCrudAction($event, 'status_create','ROLE_DATA_SKP_PESERTA')"
                                    type="checkbox"
                                    id="role-artikel-create"
                                    v-model="dataSKPPeserta.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_SKP_PESERTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_DATA_SKP_PESERTA')"
                                    id="role-artikel-read"
                                    v-model="dataSKPPeserta.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_SKP_PESERTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_DATA_SKP_PESERTA')"
                                    id="role-artikel-update"
                                    v-model="dataSKPPeserta.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_SKP_PESERTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_DATA_SKP_PESERTA')"
                                    id="role-artikel-delete"
                                    v-model="dataSKPPeserta.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_SKP_PESERTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_DATA_SKP_PESERTA')"
                                    id="role-artikel-expor"
                                    v-model="dataSKPPeserta.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="terms"
                                    type="checkbox"                     
                                    :checked="!Pelatihan.ROLE_DATA_PELAPORAN_SKP"               
                                    @change="pilihRole($event, 'ROLE_DATA_PELAPORAN_SKP')"                                    
                                  />
                                </td>
                                <td for="terms">Data Pelaporan SKP</td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PELAPORAN_SKP"
                                    @change="changeCrudAction($event, 'status_create','ROLE_DATA_PELAPORAN_SKP')"
                                    type="checkbox"
                                    id="role-artikel-create"
                                    v-model="dataPelaporanSkp.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PELAPORAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_DATA_PELAPORAN_SKP')"
                                    id="role-artikel-read"
                                    v-model="dataPelaporanSkp.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PELAPORAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_DATA_PELAPORAN_SKP')"
                                    id="role-artikel-update"
                                    v-model="dataPelaporanSkp.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PELAPORAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_DATA_PELAPORAN_SKP')"
                                    id="role-artikel-delete"
                                    v-model="dataPelaporanSkp.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PELAPORAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_DATA_PELAPORAN_SKP')"
                                    id="role-artikel-expor"
                                    v-model="dataPelaporanSkp.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Pelatihan.ROLE_DATA_PENGAJUAN_SKP"
                                    @change="pilihRole($event, 'ROLE_DATA_PENGAJUAN_SKP')"
                                    :value="{
                                      nama_role: 'ROLE_DATA_PENGAJUAN_SKP',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Data Pengajuan SKP</td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PENGAJUAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_DATA_PENGAJUAN_SKP')"
                                    id="role-data-pengajuan-skp-create"
                                    v-model="dataPengajuanSkp.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PENGAJUAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_DATA_PENGAJUAN_SKP')"
                                    id="role-data-pengajuan-skp-read"
                                    v-model="dataPengajuanSkp.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PENGAJUAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_DATA_PENGAJUAN_SKP')"
                                    id="role-data-pengajuan-skp-update"
                                    v-model="dataPengajuanSkp.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PENGAJUAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_DATA_PENGAJUAN_SKP')"
                                    id="role-data-pengajuan-skp-delete"
                                    v-model="dataPengajuanSkp.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Pelatihan.ROLE_DATA_PENGAJUAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_DATA_PENGAJUAN_SKP')"
                                    id="role-data-pengajuan-skp-export"
                                    v-model="dataPengajuanSkp.status_export_excel"
                                  />
                                </td>
                              </tr>
                           
                              
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Pelatihan -->
                  
                  <!-- Keanggotaan -->
                  <div class="card shadow">
                    <div
                      class="card-header d-flex align-items-center collapsed"
                      id="headingTwelve"
                      data-toggle="collapse"
                      data-target="#collapseTwelve"
                      aria-expanded="true"
                      aria-controls="collapseTwelve"
                      style="cursor: pointer"
                    >
                      <h6 class="mb-0 font-weight-bold">Keanggotaan</h6>
                      <div class="ml-auto pr-2 collapse-arrow">
                        <i
                          class="fa fa-chevron-down feather-icon"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>

                    <div
                      id="collapseTwelve"
                      class="collapse"
                      aria-labelledby="headingTwelve"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    id="terms"
                                    type="checkbox"                       
                                    :checked="!Keanggotaan.ROLE_MENU_KEANGGOTAAN"             
                                    @change="pilihRole($event, 'ROLE_MENU_KEANGGOTAAN')"                                    
                                  />
                                </th>
                                <th>Keanggotaan</th>
                                <th>Create</th>
                                <th>Read</th>
                                <th>Update</th>
                                <th>Delete</th>
                                <th>Ekspor Excel</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Keanggotaan.ROLE_KATEGORI_ANGGOTA"
                                    @change="pilihRole($event, 'ROLE_KATEGORI_ANGGOTA')"
                                    :value="{
                                      nama_role: 'ROLE_KATEGORI_ANGGOTA',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Kategori Anggota</td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_KATEGORI_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_KATEGORI_ANGGOTA')"
                                    id="role-kategori-anggota-create"
                                    v-model="kategoriAnggota.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_KATEGORI_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_KATEGORI_ANGGOTA')"
                                    id="role-kategori-anggota-read"
                                    v-model="kategoriAnggota.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_KATEGORI_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_KATEGORI_ANGGOTA')"
                                    id="role-kategori-anggota-update"
                                    v-model="kategoriAnggota.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_KATEGORI_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_KATEGORI_ANGGOTA')"
                                    id="role-kategori-anggota-delete"
                                    v-model="kategoriAnggota.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_KATEGORI_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_KATEGORI_ANGGOTA')"
                                    id="role-kategori-anggota-export"
                                    v-model="kategoriAnggota.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Keanggotaan.ROLE_DATA_ANGGOTA"
                                    @change="pilihRole($event, 'ROLE_DATA_ANGGOTA')"
                                    :value="{
                                      nama_role: 'ROLE_DATA_ANGGOTA',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Data Anggota</td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_DATA_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_DATA_ANGGOTA')"
                                    id="role-data-anggota-create"
                                    v-model="anggotaPelatihan.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_DATA_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_DATA_ANGGOTA')"
                                    id="role-data-anggota-read"
                                    v-model="anggotaPelatihan.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_DATA_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_DATA_ANGGOTA')"
                                    id="role-data-anggota-update"
                                    v-model="anggotaPelatihan.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_DATA_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_DATA_ANGGOTA')"
                                    id="role-data-anggota-delete"
                                    v-model="anggotaPelatihan.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_DATA_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_DATA_ANGGOTA')"
                                    id="role-data-anggota-export"
                                    v-model="anggotaPelatihan.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Keanggotaan.ROLE_KAP"
                                    @change="pilihRole($event, 'ROLE_KAP')"
                                    :value="{
                                      nama_role: 'ROLE_KAP',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>KAP</td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_KAP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_KAP')"
                                    id="role-data-kap-create"
                                    v-model="kap.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_KAP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_KAP')"
                                    id="role-data-kap-read"
                                    v-model="kap.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_KAP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_KAP')"
                                    id="role-data-kap-update"
                                    v-model="kap.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_KAP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_KAP')"
                                    id="role-data-kap-delete"
                                    v-model="kap.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_KAP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_KAP')"
                                    id="role-data-kap-export"
                                    v-model="kap.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Keanggotaan.ROLE_PELAPORAN_SKP"
                                    @change="pilihRole($event, 'ROLE_PELAPORAN_SKP')"
                                    :value="{
                                      nama_role: 'ROLE_PELAPORAN_SKP',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Pelaporan SKP</td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_PELAPORAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PELAPORAN_SKP')"
                                    id="role-data-pelaporan-skp-create"
                                    v-model="pelaporanSkp.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_PELAPORAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PELAPORAN_SKP')"
                                    id="role-data-pelaporan-skp-read"
                                    v-model="pelaporanSkp.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_PELAPORAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_PELAPORAN_SKP')"
                                    id="role-data-pelaporan-skp-update"
                                    v-model="pelaporanSkp.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_PELAPORAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_PELAPORAN_SKP')"
                                    id="role-data-pelaporan-skp-delete"
                                    v-model="pelaporanSkp.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_PELAPORAN_SKP"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_PELAPORAN_SKP')"
                                    id="role-data-pelaporan-skp-export"
                                    v-model="pelaporanSkp.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Keanggotaan.ROLE_PENGAJUAN_REKOMENDASI"
                                    @change="pilihRole($event,'ROLE_PENGAJUAN_REKOMENDASI')"
                                    :value="{
                                      nama_role: 'ROLE_PENGAJUAN_REKOMENDASI',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Pengajuan Rekomendasi</td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_PENGAJUAN_REKOMENDASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PENGAJUAN_REKOMENDASI')"
                                    id="role-data-pengajuan-rekomendasi-create"
                                    v-model="pengajuanRekomendasi.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_PENGAJUAN_REKOMENDASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PENGAJUAN_REKOMENDASI')"
                                    id="role-data-pengajuan-rekomendasi-read"
                                    v-model="pengajuanRekomendasi.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_PENGAJUAN_REKOMENDASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_PENGAJUAN_REKOMENDASI')"
                                    id="role-data-pengajuan-rekomendasi-update"
                                    v-model="pengajuanRekomendasi.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_PENGAJUAN_REKOMENDASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_PENGAJUAN_REKOMENDASI')"
                                    id="role-data-pengajuan-rekomendasi-delete"
                                    v-model="pengajuanRekomendasi.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_PENGAJUAN_REKOMENDASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_PENGAJUAN_REKOMENDASI')"
                                    id="role-data-pengajuan-rekomendasi-export"
                                    v-model="pengajuanRekomendasi.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Keanggotaan.ROLE_ASEAN_CPA"
                                    @change="pilihRole($event, 'ROLE_ASEAN_CPA')"
                                    :value="{
                                      nama_role: 'ROLE_ASEAN_CPA',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Asean CPA</td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_ASEAN_CPA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_ASEAN_CPA')"
                                    id="role-data-asean-cpa-create"
                                    v-model="aseanCpa.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_ASEAN_CPA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_ASEAN_CPA')"
                                    id="role-data-asean-cpa-read"
                                    v-model="aseanCpa.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_ASEAN_CPA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_ASEAN_CPA')"
                                    id="role-data-asean-cpa-update"
                                    v-model="aseanCpa.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_ASEAN_CPA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_ASEAN_CPA')"
                                    id="role-data-asean-cpa-delete"
                                    v-model="aseanCpa.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_ASEAN_CPA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_ASEAN_CPA')"
                                    id="role-data-asean-cpa-export"
                                    v-model="aseanCpa.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Keanggotaan.ROLE_GENERATE_ANNUAL_INVOICE"
                                    @change="pilihRole($event, 'ROLE_GENERATE_ANNUAL_INVOICE')"
                                    :value="{
                                      nama_role: 'ROLE_GENERATE_ANNUAL_INVOICE',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Iuran Anggota</td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_GENERATE_ANNUAL_INVOICE"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_GENERATE_ANNUAL_INVOICE')"
                                    id="role-data-invoice-create"
                                    v-model="iuranAnggota.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_GENERATE_ANNUAL_INVOICE"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_GENERATE_ANNUAL_INVOICE')"
                                    id="role-data-invoice-read"
                                    v-model="iuranAnggota.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_GENERATE_ANNUAL_INVOICE"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_GENERATE_ANNUAL_INVOICE')"
                                    id="role-data-invoice-update"
                                    v-model="iuranAnggota.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_GENERATE_ANNUAL_INVOICE"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_GENERATE_ANNUAL_INVOICE')"
                                    id="role-data-invoice-delete"
                                    v-model="iuranAnggota.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_GENERATE_ANNUAL_INVOICE"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_GENERATE_ANNUAL_INVOICE')"
                                    id="role-data-invoice-export"
                                    v-model="iuranAnggota.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Keanggotaan.ROLE_ANGGOTA_UMUM"
                                    @change="pilihRole($event, 'ROLE_ANGGOTA_UMUM')"
                                    :value="{
                                      nama_role: 'ROLE_ANGGOTA_UMUM',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Anggota Umum</td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_ANGGOTA_UMUM"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_ANGGOTA_UMUM')"
                                    id="role-data-anggota-umum-create"
                                    v-model="anggotaUmum.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_ANGGOTA_UMUM"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_ANGGOTA_UMUM')"
                                    id="role-data-anggota-umum-read"
                                    v-model="anggotaUmum.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_ANGGOTA_UMUM"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_ANGGOTA_UMUM')"
                                    id="role-data-anggota-umum-update"
                                    v-model="anggotaUmum.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_ANGGOTA_UMUM"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_ANGGOTA_UMUM')"
                                    id="role-data-anggota-umum-delete"
                                    v-model="anggotaUmum.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_ANGGOTA_UMUM"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_ANGGOTA_UMUM')"
                                    id="role-data-anggota-umum-export"
                                    v-model="anggotaUmum.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Keanggotaan.ROLE_SANKSI_ANGGOTA"
                                    @change="pilihRole($event, 'ROLE_SANKSI_ANGGOTA')"
                                    :value="{
                                      nama_role: 'ROLE_SANKSI_ANGGOTA',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Sanksi Anggota</td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_SANKSI_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_SANKSI_ANGGOTA')"
                                    id="role-sanksi-anggota-create"
                                    v-model="sanksiAnggota.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_SANKSI_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_SANKSI_ANGGOTA')"
                                    id="role-sanksi-anggota-read"
                                    v-model="sanksiAnggota.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_SANKSI_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_SANKSI_ANGGOTA')"
                                    id="role-sanksi-anggota-update"
                                    v-model="sanksiAnggota.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_SANKSI_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_SANKSI_ANGGOTA')"
                                    id="role-sanksi-anggota-delete"
                                    v-model="sanksiAnggota.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_SANKSI_ANGGOTA"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_SANKSI_ANGGOTA')"
                                    id="role-sanksi-anggota-export"
                                    v-model="sanksiAnggota.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Keanggotaan.ROLE_STATISTIK"
                                    @change="pilihRole($event, 'ROLE_STATISTIK')"
                                    :value="{
                                      nama_role: 'ROLE_STATISTIK',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Statistik</td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_STATISTIK"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_STATISTIK')"
                                    id="role-data-statistik-create"
                                    v-model="statistik.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_STATISTIK"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_STATISTIK')"
                                    id="role-data-statistik-read"
                                    v-model="statistik.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_STATISTIK"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_STATISTIK')"
                                    id="role-data-statistik-update"
                                    v-model="statistik.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_STATISTIK"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_STATISTIK')"
                                    id="role-data-statistik-delete"
                                    v-model="statistik.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Keanggotaan.ROLE_STATISTIK"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_STATISTIK')"
                                    id="role-data-statistik-export"
                                    v-model="statistik.status_export_excel"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>  
                  <!-- Keanggotaan -->
                  
                  <!-- Finance -->
                  <div class="card shadow">
                    <div
                      class="card-header d-flex align-items-center collapsed"
                      id="headingSix"
                      data-toggle="collapse"
                      data-target="#collapseSix"
                      aria-expanded="false"
                      aria-controls="collapseSix"
                      style="cursor: pointer"
                    >
                      <h6 class="mb-0 font-weight-bold">Keuangan</h6>
                      <div class="ml-auto pr-2 collapse-arrow">
                        <i
                          class="fa fa-chevron-down feather-icon"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div
                      id="collapseSix"
                      class="collapse"
                      aria-labelledby="headingSix"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    id="terms"
                                    type="checkbox"            
                                    :checked="!Finance.ROLE_MENU_FINANCE"                        
                                    @change="pilihRole($event, 'ROLE_MENU_FINANCE')"                                    
                                  />
                                </th>
                                <th>Keuangan</th>
                                <th>Create</th>
                                <th>Read</th>
                                <th>Update</th>
                                <th>Delete</th>
                                <th>Ekspor Excel</th>
                              </tr>
                            </thead>
                            <tbody>                              
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Finance.ROLE_PAYMENT"
                                    @change="pilihRole($event, 'ROLE_PAYMENT')"
                                    :value="{
                                      nama_role: 'ROLE_PAYMENT',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Pembayaran</td>
                                <td>
                                  <input
                                    :disabled="Finance.ROLE_PAYMENT"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_PAYMENT')"
                                    id="role-payment-create"
                                    v-model="payment.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Finance.ROLE_PAYMENT"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_PAYMENT')"
                                    id="role-payment-read"
                                    v-model="payment.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Finance.ROLE_PAYMENT"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_E_KWITANSI')"
                                    id="role-payment-update"
                                    v-model="payment.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Finance.ROLE_PAYMENT"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_E_KWITANSI')"
                                    id="role-payment-delete"
                                    v-model="payment.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Finance.ROLE_PAYMENT"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_E_KWITANSI')"
                                    id="role-payment-export"
                                    v-model="payment.status_export_excel"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Finance -->
                  
                  <!-- Broadcast -->
                  <div class="card shadow">
                    <div
                      class="card-header d-flex align-items-center collapsed"
                      id="headingSeven"
                      data-toggle="collapse"
                      data-target="#collapseSeven"
                      aria-expanded="false"
                      aria-controls="collapseSeven"
                      style="cursor: pointer"
                    >
                      <h6 class="mb-0 font-weight-bold">Broadcast</h6>
                      <div class="ml-auto pr-2 collapse-arrow">
                        <i
                          class="fa fa-chevron-down feather-icon"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <div
                      id="collapseSeven"
                      class="collapse"
                      aria-labelledby="headingSeven"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    id="terms"
                                    type="checkbox"          
                                    :checked="!Broadcast.ROLE_MENU_BROADCAST"                          
                                    @change="pilihRole($event, 'ROLE_MENU_BROADCAST')"                                    
                                  />
                                </th>                                
                                <th>Broadcast</th>
                                <th>Create</th>
                                <th>Read</th>
                                <th>Update</th>
                                <th>Delete</th>
                                <th>Ekspor Excel</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Broadcast.ROLE_EMAIL_BROADCAST"
                                    @change="pilihRole($event, 'ROLE_EMAIL_BROADCAST')"
                                    :value="{
                                      nama_role: 'ROLE_EMAIL_BROADCAST',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Broadcast Email</td>
                                <td>
                                  <input
                                    :disabled="Broadcast.ROLE_EMAIL_BROADCAST"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_EMAIL_BROADCAST')"
                                    id="role-broadast-email-create"
                                    v-model="broadcastEmail.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Broadcast.ROLE_EMAIL_BROADCAST"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_EMAIL_BROADCAST')"
                                    id="role-broadast-email-read"
                                    v-model="broadcastEmail.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Broadcast.ROLE_EMAIL_BROADCAST"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_EMAIL_BROADCAST')"
                                    id="role-broadast-email-update"
                                    v-model="broadcastEmail.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Broadcast.ROLE_EMAIL_BROADCAST"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_EMAIL_BROADCAST')"
                                    id="role-broadast-email-delete"
                                    v-model="broadcastEmail.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Broadcast.ROLE_EMAIL_BROADCAST"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_EMAIL_BROADCAST')"
                                    id="role-broadast-email-export"
                                    v-model="broadcastEmail.status_export_excel"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td scope="row">
                                  <input
                                    id="id_divisi"
                                    type="checkbox"
                                    :checked="!Broadcast.ROLE_BROADCAST_APLIKASI"
                                    @change="pilihRole($event, 'ROLE_BROADCAST_APLIKASI')"
                                    :value="{
                                      nama_role: 'ROLE_BROADCAST_APLIKASI',
                                      status_create: '0',
                                      status_read: '0',
                                      status_update: '0',
                                      status_delete: '0',
                                    }"
                                  />
                                </td>
                                <td>Broadcast Pesan Aplikasi</td>
                                <td>
                                  <input
                                    :disabled="Broadcast.ROLE_BROADCAST_APLIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_create','ROLE_BROADCAST_APLIKASI')"
                                    id="role-broadast-aplikasi-create"
                                    v-model="broadcastApp.status_create"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Broadcast.ROLE_BROADCAST_APLIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_read','ROLE_BROADCAST_APLIKASI')"
                                    id="role-broadast-aplikasi-read"
                                    v-model="broadcastApp.status_read"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Broadcast.ROLE_BROADCAST_APLIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_update','ROLE_BROADCAST_APLIKASI')"
                                    id="role-broadast-aplikasi-update"
                                    v-model="broadcastApp.status_update"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Broadcast.ROLE_BROADCAST_APLIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_delete','ROLE_BROADCAST_APLIKASI')"
                                    id="role-broadast-aplikasi-delete"
                                    v-model="broadcastApp.status_delete"
                                  />
                                </td>
                                <td>
                                  <input
                                    :disabled="Broadcast.ROLE_BROADCAST_APLIKASI"
                                    type="checkbox"
                                    @change="changeCrudAction($event, 'status_export_excel','ROLE_BROADCAST_APLIKASI')"
                                    id="role-broadast-aplikasi-export"
                                    v-model="broadcastApp.status_export_excel"
                                  />
                                </td>
                              </tr>                              
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Broadcast -->

                  <!-- Log Activity -->
                  <div class="card shadow">
                    <div class="card-header d-flex align-items-center">
                      <div class="mr-auto pr-2">
                        <div class="form-check">
                          <input 
                            class="form-check-input" 
                            type="checkbox" 
                            v-model="logActivity.status_read"
                            @change="pilihRole($event,'ROLE_LOG')"                          
                            :value="{
                              nama_role: 'ROLE_LOG',
                              status_create: true,
                              status_read: true,
                              status_update: true,
                              status_delete: true,
                            }"
                            id="defaultCheck1"
                          >
                          <label class="form-check-label font-weight-bold" for="defaultCheck1">
                            Log Activity
                          </label>
                        </div>                                              
                      </div>                      
                    </div>                    
                  </div>
                  <!-- Log Activity -->
                </div>
                <Button class="btn btn-md btn-success px-4 py-2 float-right" type="submit" color="success" @click="postData">
                  Ubah
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email } from "vuelidate/lib/validators";

import PetugasIapiService from "../../../services/user-manajemen/petugas-iapi.service";
import permissionsMixins from "../../../mixins/petugasIapi/permissionsMixins";
import { AlertUtils } from "../../../mixins/AlertUtils";
import { Cabang } from "../../../mixins/master/Cabang";
import { Divisi } from "../../../mixins/master/Divisi";

import BaseUrl from "../../../services/base-url";

export default {
  name: "EditPetugasIapi",

  mixins: [
    AlertUtils, 
    Cabang, 
    Divisi,
    permissionsMixins
  ],

  data: function() {
    return {
      baseUrl: "",
      formData: {
        username: "",
        name: "",
        email: "",
        password: "",
        noTelephone: "",
        status: "",
        foto: "",
        tipePetugas: "iapi",
        roles: [],
        divisi: {},
        cabang: {}
      },             
      fileUrl: ''      
    };
  },

  validations: {
    formData: {
      name: { required },
      username: { required },
      email: { required, email },   
    },
    multi_master_cabang: { required },
    multi_master_divisi: { required },
  },  

  mounted() {
    this.baseUrl = BaseUrl();
    const id = this.$route.params && this.$route.params.id_user;
    this.getAllDivisi();
    this.getAllCabang();  
    this.getDetailPetugasIapi(id);
  },

  methods: {
    cekRoleProfile(roleName) {
      var user = JSON.parse(localStorage.getItem('user'));
      if(user.singleData == {}) {
        return false;
      }

      if(user.singleData.detail_user.roles == null) {
        return false
      }  
      
      var data = user.singleData.detail_user.roles.find(el => el.nama_role === roleName );
      if(data == undefined || data == 'undefined') {
        return false;
      } else {
        if(data.status_update ==false &&
          data.status_read == false &&
          data.status_create == false &&
          data.status_delete == false ) {
            return false
        } else {
          if(this.$route.query.type != undefined) {
            return false;
          } else {
            return true;
          }
          // return true;
        }
      }
    },
    imgError(e) {
      e.target.src = '/img/avatars/2.jpeg'
    },
    getDetailPetugasIapi(id) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      PetugasIapiService.getDetailPetugasIapi(id)
        .then(response => {                              
          this.formData = response.data.data[0];          
          setTimeout(() => {
            this.multi_master_divisi = this.optionMasterDivisi.find(el => el.idDivisi === this.formData.divisi.id_divisi);
            this.formData.idDivisi = this.formData.divisi.id_divisi;      
            this.multi_master_cabang = this.optionMasterCabang.find(el => el.idCabang === this.formData.cabang.id_cabang);          
            this.formData.idCabang = this.formData.cabang.id_cabang;
          }, 1000);
          this.formData.password = ""
          this.getUserRoles();
          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error)
          loader.hide();
        })
    },

    postData() {                       
      this.$v.$touch();
      if (this.$v.$invalid) {
        window.scrollTo({top: 0, behavior: 'smooth'});
        return;
      } else {          
        this.putData();
      }      
    },    

    changeCrudAction(e, statusType, nama_role) {      
      // // comment console console.log(e);
      // // comment console console.log(statusType);
      // // comment console console.log(nama_role);       
    },

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
            
      this.pushRolesToFormData();           

      if (typeof this.formData.foto === "string") {
        delete this.formData.foto;
      }

      if (this.formData.foto === null) {
        delete this.formData.foto;
      }
      
      // Remove Duplicates Roles
      this.formData.roles = this.formData.roles.reduce((acc, current) => {
        const x = acc.find(item => item.nama_role === current.nama_role);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);      

      PetugasIapiService.putPetugasIapi(this.formData)
        .then((response) => {          
          loader.hide();
          if(this.$route.query.type != undefined) {
            this.alertSuccess();                
          } else {
            this.alertSuccess();    
            this.$router.push({ path: "/user-manajemen/petugas-aktif" });
          }      
        })
        .catch((error) => {
          this.alertError(error.response.data.message);
          loader.hide();
        })      
    },    

    pilihDivisi(value) {
      this.formData.idDivisi = value.idDivisi;      
    },

    pilihCabang(value) {
      this.formData.idCabang = value.idCabang;      
    },

    getUserRoles() {
      this.roleDataMaster = this.formData.roles.find(el => el.nama_role === "ROLE_MENU_MASTER");
      if(this.roleDataMaster === undefined) {
        this.roleDataMaster = {
          nama_role: "ROLE_MENU_MASTER",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.roleDataMaster)) {
        this.DataMaster.ROLE_MENU_MASTER = false;
      }

      this.InformasiUmum = this.formData.roles.find(el => el.nama_role === "ROLE_INFORMASI_UMUM");
      if(this.InformasiUmum === undefined) {
        this.InformasiUmum = {
          nama_role: "ROLE_INFORMASI_UMUM",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.InformasiUmum)) {
        this.DataMaster.ROLE_INFORMASI_UMUM = false;
      }

      this.masterArtikel = this.formData.roles.find(el => el.nama_role === "ROLE_ARTIKEL");
      if(this.masterArtikel === undefined) {
        this.masterArtikel = {
          nama_role: "ROLE_ARTIKEL",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.masterArtikel)) {
        this.DataMaster.ROLE_ARTIKEL = false;
      }

      this.divisi = this.formData.roles.find(el => el.nama_role === "ROLE_DIVISI");    
      if(this.divisi === undefined) {
        this.divisi = {
          nama_role: "ROLE_DIVISI",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.divisi)) {
        this.DataMaster.ROLE_DIVISI = false
      }
      
      this.level = this.formData.roles.find(el => el.nama_role === "ROLE_LEVEL");
      if(this.level === undefined) {
        this.level = {
          nama_role: "ROLE_LEVEL",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.level)) {
        this.DataMaster.ROLE_LEVEL = false;
      }

      this.testCenter = this.formData.roles.find(el => el.nama_role === "ROLE_TEST_CENTER");
      if(this.testCenter === undefined) {
        this.testCenter = {
          nama_role: "ROLE_TEST_CENTER",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.testCenter)){
        this.DataMaster.ROLE_TEST_CENTER = false;
      }

      this.jadwalTc = this.formData.roles.find(el => el.nama_role === "ROLE_MASTER_JADWAL_TC");
      if(this.jadwalTc === undefined) {
        this.jadwalTc = {
          nama_role: "ROLE_MASTER_JADWAL_TC",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.jadwalTc)) {
        this.DataMaster.ROLE_MASTER_JADWAL_TC = false;
      }

      this.cabang = this.formData.roles.find(el => el.nama_role === "ROLE_CABANG");
      if(this.cabang === undefined) {
        this.cabang = {
          nama_role: "ROLE_CABANG",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.cabang)) {
        this.DataMaster.ROLE_CABANG = false;
      }

      this.periode = this.formData.roles.find(el => el.nama_role === "ROLE_PERIODE");
      if(this.periode === undefined) {
        this.periode = {
          nama_role: "ROLE_PERIODE",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.periode)) {
        this.DataMaster.ROLE_PERIODE = false;
      }

      this.kupon = this.formData.roles.find(el => el.nama_role === "ROLE_KUPON");
      if(this.kupon === undefined) {
        this.kupon = {
          nama_role: "ROLE_KUPON",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.kupon)) {
        this.DataMaster.ROLE_KUPON = false;
      }

      this.lokasi = this.formData.roles.find(el => el.nama_role === "ROLE_MASTER_LOKASI");
      if(this.lokasi === undefined) {
        this.lokasi = {
          nama_role: "ROLE_MASTER_LOKASI",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.lokasi)) {
        this.DataMaster.ROLE_MASTER_LOKASI = false;
      }

      this.dokumen = this.formData.roles.find(el => el.nama_role === "ROLE_DOKUMEN");
      if(this.dokumen === undefined) {
        this.dokumen = {
          nama_role: "ROLE_DOKUMEN",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.dokumen)) {
        this.DataMaster.ROLE_DOKUMEN = false;
      }

      this.karir = this.formData.roles.find(el => el.nama_role === "ROLE_KARIR");
      if(this.karir === undefined) {
        this.karir = {
          nama_role: "ROLE_KARIR",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.karir)) {
        this.DataMaster.ROLE_KARIR = false;
      }

      this.mataKuliah = this.formData.roles.find(el => el.nama_role === "ROLE_MATA_KULIAH");
      if(this.mataKuliah === undefined) {
        this.mataKuliah = {
          nama_role: "ROLE_MATA_KULIAH",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.mataKuliah)) {
        this.DataMaster.ROLE_MATA_KULIAH = false;
      }
      
      this.mataUji = this.formData.roles.find(el => el.nama_role === "ROLE_MASTER_MATA_UJI");
      if(this.mataUji === undefined) {
        this.mataUji = {
          nama_role: "ROLE_MASTER_MATA_UJI",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.mataUji)) {
        this.DataMaster.ROLE_MASTER_MATA_UJI = false;
      }
      
      this.paktaIntegritas = this.formData.roles.find(el => el.nama_role === "ROLE_PAKTA_INTEGRITAS");
      if(this.paktaIntegritas === undefined) {
        this.paktaIntegritas = {
          nama_role: "ROLE_PAKTA_INTEGRITAS",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.paktaIntegritas)) {
        this.DataMaster.ROLE_PAKTA_INTEGRITAS = false;
      }

      // User Manajemen
      this.rolePetugas = this.formData.roles.find(el => el.nama_role === "ROLE_MENU_USER_MANAJEMEN");
      if(this.rolePetugas === undefined) {
        this.rolePetugas = {
          nama_role: "ROLE_MENU_USER_MANAJEMEN",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.rolePetugas)) {
        this.Usermanajemen.ROLE_MENU_USER_MANAJEMEN = false;
      }

      this.petugasBO = this.formData.roles.find(el => el.nama_role === "ROLE_PETUGAS_IAPI");
      if(this.petugasBO === undefined) {
        this.petugasBO = {
          nama_role: "ROLE_PETUGAS_IAPI",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.petugasBO)) {
        this.Usermanajemen.ROLE_PETUGAS_IAPI = false;
      }

      this.petugasLms = this.formData.roles.find(el => el.nama_role === "ROLE_PETUGAS_LMS");
      if(this.petugasLms === undefined) {
        this.petugasLms = {
          nama_role: "ROLE_PETUGAS_LMS",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.petugasLms)) {
        this.Usermanajemen.ROLE_PETUGAS_LMS = false;
      }

      this.petugasTc = this.formData.roles.find(el => el.nama_role === "ROLE_PETUGAS_TEST_CENTER");
      if(this.petugasTc === undefined) {
        this.petugasTc = {
          nama_role: "ROLE_PETUGAS_TEST_CENTER",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.petugasTc)) {
        this.Usermanajemen.ROLE_PETUGAS_TEST_CENTER = false;
      }

      this.petugasBankSoal = this.formData.roles.find(el => el.nama_role === "ROLE_PETUGAS_BANK_SOAL");
      if(this.petugasBankSoal === undefined) {
        this.petugasBankSoal = {
          nama_role: "ROLE_PETUGAS_BANK_SOAL",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.petugasBankSoal)) {
        this.Usermanajemen.ROLE_PETUGAS_BANK_SOAL = false;
      }
      
      this.petugasGrader = this.formData.roles.find(el => el.nama_role === "ROLE_PETUGAS_GRADER");
      if(this.petugasGrader === undefined) {
        this.petugasGrader = {
          nama_role: "ROLE_PETUGAS_GRADER",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.petugasGrader)) {
        this.Usermanajemen.ROLE_PETUGAS_GRADER = false;
      }

      // Sertifikasi
      this.roleSertifikasi = this.formData.roles.find(el => el.nama_role === "ROLE_MENU_SERTIFIKASI");
      if(this.roleSertifikasi === undefined) {
        this.roleSertifikasi = {
          nama_role: "ROLE_MENU_SERTIFIKASI",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.roleSertifikasi)) {
        this.Sertifikasi.ROLE_MENU_SERTIFIKASI = false;
      }

      this.sertifikasi = this.formData.roles.find(el => el.nama_role === "ROLE_MASTER_SERTIFIKASI");
      if(this.sertifikasi === undefined) {
        this.sertifikasi = {
          nama_role: "ROLE_MASTER_SERTIFIKASI",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.sertifikasi)) {
        this.Sertifikasi.ROLE_MASTER_SERTIFIKASI = false;
      }

      this.dataPesertaSertifikasi = this.formData.roles.find(el => el.nama_role === "ROLE_DATA_PESERTA_SERTIFIKASI");
      if(this.dataPesertaSertifikasi === undefined) {
        this.dataPesertaSertifikasi = {
          nama_role: "ROLE_DATA_PESERTA_SERTIFIKASI",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Sertifikasi.ROLE_DATA_PESERTA_SERTIFIKASI = false;
      }            

     

      this.pengajuanSertifikasi = this.formData.roles.find(el => el.nama_role === "ROLE_PENGAJUAN_SERTIFIKASI");
      if(this.pengajuanSertifikasi === undefined) {
        this.pengajuanSertifikasi = {
          nama_role: "ROLE_PENGAJUAN_SERTIFIKASI",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Sertifikasi.ROLE_PENGAJUAN_SERTIFIKASI = false;
      }      

      this.riwayatPeserta = this.formData.roles.find(el => el.nama_role === "ROLE_RIWAYAT_PESERTA");
      if(this.riwayatPeserta === undefined) {
        this.riwayatPeserta = {
          nama_role: "ROLE_RIWAYAT_PESERTA",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Sertifikasi.ROLE_RIWAYAT_PESERTA = false;
      }

      // RPL
      this.roleRpl = this.formData.roles.find(el => el.nama_role === "ROLE_MENU_RPL");
      if(this.roleRpl === undefined) {
        this.roleRpl = {
          nama_role: "ROLE_MENU_RPL",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.roleRpl)) {
        this.Rpl.ROLE_MENU_RPL = false;
      }

      this.masterRpl = this.formData.roles.find(el => el.nama_role === "ROLE_MASTER_RPL");
      if(this.masterRpl === undefined) {
        this.masterRpl = {
          nama_role: "ROLE_MASTER_RPL",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Rpl.ROLE_MASTER_RPL = false;
      }
      
      this.pesertaRpl = this.formData.roles.find(el => el.nama_role === "ROLE_DATA_PESERTA_RPL");
      if(this.pesertaRpl === undefined) {
        this.pesertaRpl = {
          nama_role: "ROLE_DATA_PESERTA_RPL",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Rpl.ROLE_DATA_PESERTA_RPL = false;
      }

      this.riwayatPesertaRpl = this.formData.roles.find(el => el.nama_role === "ROLE_RIWAYAT_PESERTA_RPL");
      if(this.riwayatPesertaRpl === undefined) {
        this.riwayatPesertaRpl = {
          nama_role: "ROLE_RIWAYAT_PESERTA_RPL",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Rpl.ROLE_RIWAYAT_PESERTA_RPL = false;
      }

      this.waiver = this.formData.roles.find(el => el.nama_role === "ROLE_WAIVER");
      if(this.waiver === undefined) {
        this.waiver = {
          nama_role: "ROLE_WAIVER",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Rpl.ROLE_WAIVER = false;
      }

      this.pengajuanSertifikasiRpl = this.formData.roles.find(el => el.nama_role === "ROLE_PENGAJUAN_SERTIFIKAT_RPL");
      if(this.pengajuanSertifikasiRpl === undefined) {
        this.pengajuanSertifikasiRpl = {
          nama_role: "ROLE_PENGAJUAN_SERTIFIKAT_RPL",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Rpl.ROLE_PENGAJUAN_SERTIFIKAT_RPL = false;
      }

      // Pelatihan
      this.rolePelatihan = this.formData.roles.find(el => el.nama_role === "ROLE_MENU_PELATIHAN");
      if(this.rolePelatihan === undefined) {
        this.rolePelatihan = {
          nama_role: "ROLE_MENU_PELATIHAN",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.rolePelatihan)) {
        this.Pelatihan.ROLE_MENU_PELATIHAN = false;
      }

      this.kodePelatihan = this.formData.roles.find(el => el.nama_role === "ROLE_KODE_PELATIHAN");
      if(this.kodePelatihan === undefined) {
        this.kodePelatihan = {
          nama_role: "ROLE_KODE_PELATIHAN",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Pelatihan.ROLE_KODE_PELATIHAN = false;
      }

      this.daftarPelatihan = this.formData.roles.find(el => el.nama_role === "ROLE_DAFTAR_PELATIHAN");
      if(this.daftarPelatihan === undefined) {
        this.daftarPelatihan = {
          nama_role: "ROLE_DAFTAR_PELATIHAN",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Pelatihan.ROLE_DAFTAR_PELATIHAN = false;
      }
      
      this.dataSKPPeserta = this.formData.roles.find(el => el.nama_role === "ROLE_DATA_SKP_PESERTA");
      if(this.dataSKPPeserta === undefined) {
        this.dataSKPPeserta = {
          nama_role: "ROLE_DATA_SKP_PESERTA",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Pelatihan.ROLE_DATA_SKP_PESERTA = false;
      }

      this.penyelenggara = this.formData.roles.find(el => el.nama_role === "ROLE_PENYELENGGARA");
      if(this.penyelenggara === undefined) {
        this.penyelenggara = {
          nama_role: "ROLE_PENYELENGGARA",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Pelatihan.ROLE_PENYELENGGARA = false;
      }

      this.instruktur = this.formData.roles.find(el => el.nama_role === "ROLE_INSTRUKTUR");
      if(this.instruktur === undefined) {
        this.instruktur = {
          nama_role: "ROLE_INSTRUKTUR",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Pelatihan.ROLE_INSTRUKTUR = false;
      }

      this.mitraPelatihan = this.formData.roles.find(el => el.nama_role === "ROLE_MITRA_PELATIHAN");
      if(this.mitraPelatihan === undefined) {
        this.mitraPelatihan = {
          nama_role: "ROLE_MITRA_PELATIHAN",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Pelatihan.ROLE_MITRA_PELATIHAN = false;
      }

      this.dataPesertaPelatihan = this.formData.roles.find(el => el.nama_role === "ROLE_DATA_PESERTA_PELATIHAN");
      if(this.dataPesertaPelatihan === undefined) {
        this.dataPesertaPelatihan = {
          nama_role: "ROLE_DATA_PESERTA_PELATIHAN",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Pelatihan.ROLE_DATA_PESERTA_PELATIHAN = false;
      }

      this.dataPengajuanSkp = this.formData.roles.find(el => el.nama_role === "ROLE_DATA_PENGAJUAN_SKP");
      if(this.dataPengajuanSkp === undefined) {
        this.dataPengajuanSkp = {
          nama_role: "ROLE_DATA_PENGAJUAN_SKP",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Pelatihan.ROLE_DATA_PENGAJUAN_SKP = false;
      }
      
      this.dataPelaporanSkp = this.formData.roles.find(el => el.nama_role === "ROLE_DATA_PELAPORAN_SKP");
      if(this.dataPelaporanSkp === undefined) {
        this.dataPelaporanSkp = {
          nama_role: "ROLE_DATA_PELAPORAN_SKP",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Pelatihan.ROLE_DATA_PELAPORAN_SKP = false;
      }

      this.kuesioner = this.formData.roles.find(el => el.nama_role === "ROLE_KUSIONER");
      if(this.kuesioner === undefined) {
        this.kuesioner = {
          nama_role: "ROLE_KUSIONER",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Pelatihan.ROLE_KUSIONER = false;
      }

      this.signature = this.formData.roles.find(el => el.nama_role === "ROLE_SIGNATURE");
      if(this.signature === undefined) {
        this.signature = {
          nama_role: "ROLE_SIGNATURE",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Pelatihan.ROLE_SIGNATURE = false;
      }

      this.certificate = this.formData.roles.find(el => el.nama_role === "ROLE_ECERTIFICATE");
      if(this.certificate === undefined) {
        this.certificate = {
          nama_role: "ROLE_ECERTIFICATE",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Pelatihan.ROLE_ECERTIFICATE = false;
      }

      // Keanggotaan
      this.roleKeanggotaan = this.formData.roles.find(el => el.nama_role === "ROLE_MENU_KEANGGOTAAN");
      if(this.roleKeanggotaan === undefined) {
        this.roleKeanggotaan = {
          nama_role: "ROLE_MENU_KEANGGOTAAN",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.roleKeanggotaan)) {
        this.Keanggotaan.ROLE_MENU_KEANGGOTAAN = false;
      }
      
      this.kategoriAnggota = this.formData.roles.find(el => el.nama_role === "ROLE_KATEGORI_ANGGOTA");
      if(this.kategoriAnggota === undefined) {
        this.kategoriAnggota = {
          nama_role: "ROLE_KATEGORI_ANGGOTA",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Keanggotaan.ROLE_KATEGORI_ANGGOTA = false;
      }

      this.anggotaPelatihan = this.formData.roles.find(el => el.nama_role === "ROLE_DATA_ANGGOTA");
      if(this.anggotaPelatihan === undefined) {
        this.anggotaPelatihan = {
          nama_role: "ROLE_DATA_ANGGOTA",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Keanggotaan.ROLE_DATA_ANGGOTA = false;
      }

      this.kap = this.formData.roles.find(el => el.nama_role === "ROLE_KAP");
      if(this.kap === undefined) {
        this.kap = {
          nama_role: "ROLE_KAP",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Keanggotaan.ROLE_KAP = false;
      }

      this.pelaporanSkp = this.formData.roles.find(el => el.nama_role === "ROLE_PELAPORAN_SKP");
      if(this.pelaporanSkp === undefined) {
        this.pelaporanSkp = {
          nama_role: "ROLE_PELAPORAN_SKP",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Keanggotaan.ROLE_PELAPORAN_SKP = false;
      }

      this.pengajuanRekomendasi = this.formData.roles.find(el => el.nama_role === "ROLE_PENGAJUAN_REKOMENDASI");
      if(this.pengajuanRekomendasi === undefined) {
        this.pengajuanRekomendasi = {
          nama_role: "ROLE_PENGAJUAN_REKOMENDASI",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Keanggotaan.ROLE_PENGAJUAN_REKOMENDASI = false;
      }

      this.aseanCpa = this.formData.roles.find(el => el.nama_role === "ROLE_ASEAN_CPA");
      if(this.aseanCpa === undefined) {
        this.aseanCpa = {
          nama_role: "ROLE_ASEAN_CPA",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Keanggotaan.ROLE_ASEAN_CPA = false;
      }

      this.iuranAnggota = this.formData.roles.find(el => el.nama_role === "ROLE_GENERATE_ANNUAL_INVOICE");
      if(this.iuranAnggota === undefined) {
        this.iuranAnggota = {
          nama_role: "ROLE_GENERATE_ANNUAL_INVOICE",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Keanggotaan.ROLE_GENERATE_ANNUAL_INVOICE = false;
      }

      this.anggotaUmum = this.formData.roles.find(el => el.nama_role === "ROLE_ANGGOTA_UMUM");
      if(this.anggotaUmum === undefined) {
        this.anggotaUmum = {
          nama_role: "ROLE_ANGGOTA_UMUM",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Keanggotaan.ROLE_ANGGOTA_UMUM = false;
      }

      this.sanksiAnggota = this.formData.roles.find(el => el.nama_role === "ROLE_SANKSI_ANGGOTA");
      if(this.sanksiAnggota === undefined) {
        this.sanksiAnggota = {
          nama_role: "ROLE_SANKSI_ANGGOTA",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Keanggotaan.ROLE_SANKSI_ANGGOTA = false;
      }

      this.statistik = this.formData.roles.find(el => el.nama_role === "ROLE_STATISTIK");
      if(this.statistik === undefined) {
        this.statistik = {
          nama_role: "ROLE_STATISTIK",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Keanggotaan.ROLE_STATISTIK = false;
      }

      // Finance
      this.roleFinance = this.formData.roles.find(el => el.nama_role === "ROLE_MENU_FINANCE");
      if(this.roleFinance === undefined) {
        this.roleFinance = {
          nama_role: "ROLE_MENU_FINANCE",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.roleFinance)) {
        this.Finance.ROLE_MENU_FINANCE = false;
      }

      this.payment = this.formData.roles.find(el => el.nama_role === "ROLE_PAYMENT");
      if(this.payment === undefined) {
        this.payment = {
          nama_role: "ROLE_PAYMENT",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Finance.ROLE_PAYMENT = false;
      }

      this.kwitansi = this.formData.roles.find(el => el.nama_role === "ROLE_E_KWITANSI");
      if(this.kwitansi === undefined) {
        this.kwitansi = {
          nama_role: "ROLE_E_KWITANSI",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Finance.ROLE_E_KWITANSI = false;
      }

      // Broadcast
      this.roleBroadcast = this.formData.roles.find(el => el.nama_role === "ROLE_MENU_BROADCAST");
      if(this.roleBroadcast === undefined) {
        this.roleBroadcast = {
          nama_role: "ROLE_MENU_BROADCAST",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else if(this.checkRole(this.roleBroadcast)) {
        this.Broadcast.ROLE_MENU_BROADCAST = false;
      }

      this.broadcastEmail = this.formData.roles.find(el => el.nama_role === "ROLE_EMAIL_BROADCAST");
      if(this.broadcastEmail === undefined) {
        this.broadcastEmail = {
          nama_role: "ROLE_EMAIL_BROADCAST",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Broadcast.ROLE_EMAIL_BROADCAST = false;
      }

      this.broadcastApp = this.formData.roles.find(el => el.nama_role === "ROLE_BROADCAST_APLIKASI");
      if(this.broadcastApp === undefined) {
        this.broadcastApp = {
          nama_role: "ROLE_BROADCAST_APLIKASI",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.Broadcast.ROLE_BROADCAST_APLIKASI = false;
      }

      this.logActivity = this.formData.roles.find(el => el.nama_role === "ROLE_LOG");
      if(this.logActivity === undefined) {
        this.logActivity = {
          nama_role: "ROLE_LOG",
          status_create: false,
          status_read: false,
          status_update: false,
          status_delete: false,
          status_export_excel: false
        }
      } else {
        this.LogActivity.ROLE_LOG = false;
      }
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>